import { render, staticRenderFns } from "./documentiProdotti.vue?vue&type=template&id=45fa9970&"
import script from "./documentiProdotti.vue.ts?vue&type=script&lang=ts&"
export * from "./documentiProdotti.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports